import { useEffect, useRef } from 'react';

import { type DerivedEventFilterLegacy, type FilterLegacy } from '@verantos-dev/types-cohorts';

export const useDerivedEventScroll = (
  eventFilters: DerivedEventFilterLegacy[],
  temporalEventFilters: FilterLegacy[],
  uniquenessFilters: FilterLegacy[]
) => {
  //
  // scroll to bottom of section when add filter actions
  //
  const headerRef = useRef<HTMLDivElement>(null);
  const dialogContentRef = useRef<HTMLDivElement>(null);
  const eventRef = useRef<HTMLDivElement>(null);
  const temportalConstraintRef = useRef<HTMLDivElement>(null);
  const uniquenessFilterRef = useRef<HTMLDivElement>(null);

  const headerHeight = Math.round(headerRef?.current?.clientHeight ?? 0) + 16;

  // scroll when a concept filter is added
  useEffect(() => {
    const componentDiv = dialogContentRef.current;
    const eventFilterrDiv = eventRef.current;

    if (eventFilterrDiv && componentDiv) {
      if (headerHeight + eventFilterrDiv.clientHeight - componentDiv.clientHeight > 0) {
        componentDiv.scrollTo({
          left: 0,
          top: headerHeight + eventFilterrDiv.clientHeight - componentDiv.clientHeight + 16,
          behavior: 'auto',
        });
      }
    }
  }, [eventFilters.length, headerHeight]);

  // scroll when a numeric filter is added
  useEffect(() => {
    const componentDiv = dialogContentRef.current;
    const eventFilterDiv = eventRef.current;
    const temporalConstraintsDiv = temportalConstraintRef.current;

    let eventFilterHeight = 0;
    if (eventFilterDiv) {
      eventFilterHeight = eventFilterDiv.clientHeight + 16;
    }

    if (temporalConstraintsDiv && componentDiv) {
      if (
        headerHeight +
          eventFilterHeight +
          temporalConstraintsDiv.clientHeight -
          componentDiv.clientHeight >
        0
      ) {
        componentDiv.scrollTo({
          left: 0,
          top:
            headerHeight +
            eventFilterHeight +
            temporalConstraintsDiv.clientHeight -
            componentDiv.clientHeight +
            16,
          behavior: 'auto',
        });
      }
    }
  }, [headerHeight, temporalEventFilters.length]);

  // scroll when uniqueness filter is added
  useEffect(() => {
    const componentDiv = dialogContentRef.current;
    const eventFilterDiv = eventRef.current;
    const uniquenessFilterDiv = uniquenessFilterRef.current;

    let eventFilterHeight = 0;
    if (eventFilterDiv) {
      eventFilterHeight = eventFilterDiv.clientHeight + 16;
    }

    if (uniquenessFilterDiv && componentDiv) {
      if (
        headerHeight +
          eventFilterHeight +
          uniquenessFilterDiv.clientHeight -
          componentDiv.clientHeight >
        0
      ) {
        componentDiv.scrollTo({
          left: 0,
          top:
            headerHeight +
            eventFilterHeight +
            uniquenessFilterDiv.clientHeight -
            (componentDiv.clientHeight + 16),
          behavior: 'auto',
        });
      }
    }
  }, [headerHeight, uniquenessFilters.length]);

  return {
    headerRef,
    dialogContentRef,
    eventRef,
    temportalConstraintRef,
    uniquenessFilterRef,
  };
};
